import { useTranslation } from "react-i18next";
import RobinPage from "../components/core/RobinPage";
import {
  useDeleteWorkingHoursMutation,
  useGetAllMyWorkingHoursQuery,
} from "../graphql/generated/hooks";
import EditDeleteActions from "../components/EditDeleteActions";
import { Button, message, Table, Typography } from "antd";
import { faRotateRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import MutateWorkingHoursDrawer from "../components/MutateWorkingHoursDrawer";

function WorkingHours() {
  const { t } = useTranslation();
  const [messageApi, contextHolder] = message.useMessage();

  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [isDrawerRendered, setIsDrawerRendered] = useState(false);

  useEffect(() => {
    if (isDrawerOpen) setIsDrawerRendered(true);
    else {
      setTimeout(() => {
        setIsDrawerRendered(false);
      }, 300);
    }
  }, [isDrawerOpen]);

  const [editModeState, setEditModeState] = useState<{
    isEdit: boolean;
    initialValues?: any;
  }>({ isEdit: false });

  const { data, loading, refetch } = useGetAllMyWorkingHoursQuery();
  const [deleteWorkingHours, { loading: deleting }] =
    useDeleteWorkingHoursMutation();

  const dataSource = data?.getAllWorkingHoursForPartner?.map(
    (workingHours) => ({
      key: workingHours.id,
      name: workingHours.name,
      priority: workingHours.priority,
      startDate: workingHours.startDate,
      endDate: workingHours.endDate,
      actions: (
        <EditDeleteActions
          onEdit={() => {
            setIsDrawerOpen(true);
            setEditModeState({ isEdit: true, initialValues: workingHours });
          }}
          onDelete={() => {
            deleteWorkingHours({ variables: { id: workingHours.id } })
              .then(() => {
                messageApi.success(t("message.success.data_deleted"));
                refetch();
              })
              .catch((error) => {
                messageApi.error(t("message.error.data_delete_failed"));
              });
          }}
          loadingDelete={deleting}
        />
      ),
    })
  );

  const columns = [
    {
      title: t("label.name"),
      dataIndex: "name",
      key: "name",
    },
    {
      title: t("label.priority"),
      dataIndex: "priority",
      key: "priority",
    },
    {
      title: t("label.start_date"),
      dataIndex: "startDate",
      key: "startDate",
    },
    {
      title: t("label.end_date"),
      dataIndex: "endDate",
      key: "endDate",
    },
    { 
      title: t("label.actions"), 
      dataIndex: "actions", 
      key: "actions",
    },
  ];

  return (
    <RobinPage
      title={t("label.menu.workingHours")}
      actions={[
        {
          label: (
            <Typography.Link
              onClick={() => {
                refetch();
              }}
            >
              <FontAwesomeIcon icon={faRotateRight} />
            </Typography.Link>
          ),
        },
        {
          label: (
            <Button
              onClick={() => {
                setEditModeState({ isEdit: false });
                setIsDrawerOpen(true);
              }}
            >
              {t("button.add")}
            </Button>
          ),
        },
      ]}
    >
      {contextHolder}
      <Table loading={loading} dataSource={dataSource} columns={columns} />
      {isDrawerRendered && (
        <MutateWorkingHoursDrawer
          refetch={refetch}
          open={isDrawerOpen}
          onClose={() => {
            setIsDrawerOpen(false);
          }}
          edit={editModeState.isEdit}
          editData={
            editModeState.isEdit ? editModeState.initialValues : undefined
          }
        />
      )}
    </RobinPage>
  );
}

export default WorkingHours;
